export { default, ISaleLabelProps, ISaleLabelTranslations } from './SaleLabel';
export { ISaleLabelListInput } from './interfaces';
